export default {"src":"/_next/static/media/icon-speed.ddb229bf.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};